// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"b5349d1f","94":"975f58ea","161":"00bfad09","220":"f766d9fd","229":"aafb8f3b","291":"0159fe9d","452":"aadebf79","453":"03346f77","538":"9658bc22","611":"1c8e5e83","673":"c958c3c4","719":"f9694f1a","918":"2d8e57d9"}[chunkId] + ".chunk.js";
};